const colors = [
	'White',
	'Yellow',
	'Blue',
	'Red',
	'Green',
	'Black',
	'Brown',
	'Azure',
	'Ivory',
	'Teal',
	'Silver',
	'Purple',
	'Green',
	'Gray',
	'Orange',
	'Maroon',
	'Charcoal',
	'Aquamarine',
	'Coral',
	'Fuchsia',
	'Wheat',
	'Lime',
	'Crimson',
	'Khaki',
	'Pink',
	'Magenta',
	'Olden',
	'Plum',
	'Olive',
	'Cyan',
]

const bugs = [
	'Alderfly',
	'Ant',
	'Antlion',
	'Asparagus Beetle',
	'Barklice',
	'Bee',
	'Beetle',
	'Bess Beetle',
	'Billbug',
	'Bristletail',
	'Butterfly',
	'Bumblebee',
	'Caterpillar',
	'Carpenter Bee',
	'Centipede',
	'Cockroach',
	'Cricket',
	'Cuckoo Wasp',
	'Click Beetle',
	'Cicada',
	'Damselfly',
	'Diamondback Moth',
	'Dragonfly',
	'Dung Beetle',
	'Flower Beetle',
	'Fly',
	'Fire Ant',
	'Fig Wasp',
	'Grasshopper',
	'Honey Ant',
	'Honeybee',
	'Horntail',
	'Hawk Moth',
	'Ladybug',
	'Leaf Beetle',
	'Mantid',
	'Mayfly',
	'Mining Bee',
	'Mosquito',
	'Moth',
	'Snail',
	'Leafcutter Ant',
	'Locust',
	'Wasp',
	'Paper Wasp',
	'Praying Mantis',
	'Greenfly',
	'Sand Wasp',
	'Sawfly',
	'Scorpion',
	'Silkworm',
	'Snakefly',
	'Spider',
	'Spider Wasp',
	'Springtail',
	'Stick Insect',
	'Stonefly',
	'Stag Beetle',
	'Thrips',
	'Tortoise Beetle',
	'Water Bug',
	'Webspinner',
	'Weevil',
	'Wood Wasp',
]

export default function generateBugName() {
	const color = colors[Math.floor(Math.random() * colors.length)]
	const bug = bugs[Math.floor(Math.random() * bugs.length)]
	return `${color} ${bug}`
}

export function generateCamelCasedBugName() {
	return generateBugName().toLowerCase().replace(' ', '-')
}
